module.exports = __webpack_public_path__ + "img/img.2ff0dcb2.png";